import React from 'react';
import { Hero } from './components/sections/Hero';
import { Content } from './components/sections/Content';
import { Gallery } from './components/sections/Gallery';
import { Mentality } from './components/sections/Mentality';
import { Bonuses } from './components/sections/Bonuses';
import { Testimonials } from './components/sections/Testimonials';
import { Pricing } from './components/sections/Pricing';
import { FAQ } from './components/sections/FAQ';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="bg-[#0A0A0A] text-white min-h-screen w-full" data-id="element-0">
      {/* Top white border line */}
      <div className="w-full h-1 bg-white/30" data-id="element-1"></div>
      {/* Top gold gradient line underneath the white line */}
      <div className="w-full h-0.5 bg-gradient-to-r from-[#E0B84C]/80 via-[#FFD700] to-[#E0B84C]/80" data-id="element-2"></div>
      <div className="mx-auto px-4 sm:px-6 lg:px-8 w-full overflow-x-hidden" data-id="element-3">
        <Hero data-id="element-4" />
        <Content data-id="element-5" />
        <Gallery data-id="element-6" />
        <Mentality data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Pricing data-id="element-10" />
        <FAQ data-id="element-11" />
        <Footer data-id="element-12" />
      </div>
      {/* Bottom gold gradient line */}
      <div className="w-full h-0.5 bg-gradient-to-r from-[#E0B84C]/80 via-[#FFD700] to-[#E0B84C]/80" data-id="element-13"></div>
      {/* Bottom white border line */}
      <div className="w-full h-1 bg-white/30" data-id="element-14"></div>
    </div>;
}